import * as React from "react";
import {
  Checkbox,
  ClickAwayListener,
  Paper,
  Popper,
  MenuList,
  MenuItem,
  ListItemText,
} from "@mui/material";

type FilterOption = { key: string; value: string };


export default function StatusFilter(props: any) {
  const {
    openFilter,
    setOpenFilter,
    filterIconRefs,
    filters,
    selectedFilters,
    handleFilterSelect,
  } = props;
  const open = Boolean(openFilter && filters[openFilter]?.length);
  const anchorEl = openFilter ? filterIconRefs.current[openFilter] : null;
  const options = openFilter ? filters[openFilter] ?? [] : [];

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      modifiers={[
        { name: "offset", options: { offset: [0, 6] } }, // like +5px
        { name: "preventOverflow", options: { padding: 8 } },
      ]}
      style={{ zIndex: 10001 }}
    >
      <ClickAwayListener onClickAway={() => setOpenFilter(null)}>
        <Paper
          elevation={0}
          sx={{
            bgcolor: "#6e6d92",
            borderRadius: 2,
            p: 0.5,
            minWidth: 180,
            width: "max-content",
          }}
        >
          <MenuList dense sx={{ p: 0 }}>
            {options.map((opt: any) => {
              const isSelected =
                !!openFilter &&
                (selectedFilters[openFilter] ?? []).some((f: any) => f.key === opt.key);

              return (
                <MenuItem
                  key={opt.key}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (openFilter) handleFilterSelect(openFilter, opt);
                  }}
                  sx={{
                    borderRadius: 1,
                    mx: 0.5,
                    my: 0.25,
                    color: "#fff",
                    fontSize: 14,
                    fontWeight: 600,
                    fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
                    bgcolor: isSelected ? "#403c6f" : "transparent",
                    transition: "background-color 200ms ease",
                    "&:hover": { bgcolor: "#403c6f" },
                  }}
                >
                  <ListItemText primary={opt.value} />
                  <Checkbox
                    checked={isSelected}
                    tabIndex={-1}
                    disableRipple
                    sx={{
                      p: 0,
                      ml: 1,
                      color: "#fff",
                      "&.Mui-checked": { color: "#fff" },
                    }}
                  />
                </MenuItem>
              );
            })}
          </MenuList>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}